import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-add-datalake-env',
  templateUrl: './add-datalake-env.component.html',
  styleUrls: ['./add-datalake-env.component.scss'],
})
export class AddDatalakeEnvComponent implements OnInit {

  breadcrumbList = [
    {
      label: 'Datalake Environment',
      url: '/baseapp/datalake-env'
    },
    {
      label: 'Add',
      url: '/baseapp/datalake-env/add'
    }
  ];
  addDatalakeForm: UntypedFormGroup;
  hide: boolean = true;
  hide1200: boolean = false;
  userIp;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public helperService: HelperService) { }

  ngOnInit() {
    this.addDatalakeForm = this.formBuilder.group({
      op_name: ['', Validators.required],
      op_type: ['', Validators.required],
      dlversion: ['', Validators.required],
      dlhost_name: ['', Validators.required],
      dlport: ['', Validators.required],
      dlusername: ['', Validators.required],
      dlpsw: ['', Validators.required],
      dl_ca_certs_path: ['', Validators.required]
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.getUserIp();
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }

  onSubmit(){
    if (this.addDatalakeForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.helperService.loader();
    this.getStorage().then((res)=>{
      let payload = {
        created_by:res.userId,
        created_ip_address:this.userIp,
        op_name: this.addDatalakeForm.value.op_name,
        op_type: this.addDatalakeForm.value.op_type,
        dlversion: this.addDatalakeForm.value.dlversion,
        dlhost_name: this.addDatalakeForm.value.dlhost_name,
        dlport: this.addDatalakeForm.value.dlport,
        dlusername: this.addDatalakeForm.value.dlusername,
        dlpsw: this.addDatalakeForm.value.dlpsw,
        dl_ca_certs_path: this.addDatalakeForm.value.dl_ca_certs_path
      }
      this.backendService.PostAPICall('createDLEnv', payload, res.token).subscribe(
        (data) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(data.msg, 2000);
          this.router.navigate(['/baseapp/datalake-env']);
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

}
